export const TILE_WIDTH = 256;
export const TILE_HEIGHT = 128;
export const HALF_WIDTH = TILE_WIDTH / 2;
export const HALF_HEIGHT = TILE_HEIGHT / 2;
export const ELEVATION_HEIGHT = 48;

export interface Point {
  x: number;
  y: number;
}

export function gridToWorld(x: number, y: number, elevation = 0): Point {
  return {
    x: (x - y) * HALF_WIDTH,
    y: (x + y) * HALF_HEIGHT - elevation * ELEVATION_HEIGHT,
  };
}

export function worldToGrid(worldX: number, worldY: number): Point {
  return {
    x: (worldX / HALF_WIDTH + worldY / HALF_HEIGHT) / 2,
    y: (worldY / HALF_HEIGHT - worldX / HALF_WIDTH) / 2,
  };
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function cellIndex(x: number, y: number, width: number): number {
  return y * width + x;
}

export function neighbours(x: number, y: number, width: number, height: number): Point[] {
  return [
    { x: x - 1, y },
    { x: x + 1, y },
    { x, y: y - 1 },
    { x, y: y + 1 },
  ].filter((point) => point.x >= 0 && point.y >= 0 && point.x < width && point.y < height);
}

